<template>
  <div style="min-height:100px;">
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="70"
      ></v-progress-circular>
    </v-overlay>

    <LakeSearchForm />
    <v-divider class="mb-3"></v-divider>
    <v-btn
      color="success"
      @click="add()"
      small
      right
      absolute
      class="mr-3"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-simple-table v-if="LAKES.length > 0">
      <thead>
        <tr>
          <th class="text-left">
            ID
          </th>
          <th class="text-left">
            Nazwa
          </th>
          <th class="text-left">
            Topowe
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="lake in LAKES"
          :key="lake.id"
        >
          <td>{{ lake.id }}</td>
          <td>{{ lake.name }}</td>
          <td>
            <v-icon v-if="lake.isTop">star</v-icon>
          </td>

          <td style="text-align:right;">

            <v-btn
              depressed
              small
              color="primary"
              @click="showEditDialog(lake)"
            >
              edytuj
            </v-btn>

          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <LakeForm ref="lakeForm" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LakeForm from "./AdminLake/LakeForm";
import LakeSearchForm from "./AdminLake/LakeSearchForm";

export default {
  name: "AdminLake",
  components: {
    LakeForm,
    LakeSearchForm,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters(["LAKES"]),
  },
  methods: {
    showEditDialog(item) {
      this.$refs.lakeForm.open(item);
    },

    add() {
      this.$refs.lakeForm.open({
        cities: [],
      });
    },
  },
  mounted() {
    /*this.loading = true;
    this.$store.dispatch("GET_LAKES").then(() => {
      this.loading = false;
    });*/
  },
};
</script>


<style>
</style>